import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import Environment from "../../utils/Environment";
import { usdtContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import { BigNumber, utils } from "ethers";

export const Allowance = () => {
    const web3 = useWeb3();
    const { account } = useWeb3React();

    // ✅ New function to only check allowance (no approval)
    const checkAllowanceOnly = useCallback(
        async (allowanceAddress, contractAddress, rewardAmount, decimal) => {
            if (!account || !contractAddress || !rewardAmount) return "0";

            try {
                const contract = usdtContract(contractAddress, web3);
                let amount = decimal === 18
                    ? web3.utils.toWei(rewardAmount.toString(), 'ether')
                    : (rewardAmount * Math.pow(10, decimal)).toString();

                const currentAllowance = await contract.methods.allowance(account, allowanceAddress).call();
                return currentAllowance;
            } catch (err) {
                console.error("Error while checking allowance:", err);
                return "0";
            }
        },
        [web3, account]
    );

    // ✅ Full approval logic
    const AllowanceCore = useCallback(
        async (allowanceAddresss, contractAddress, rewardAmount, decimal, currency) => {
            console.log(allowanceAddresss, contractAddress, rewardAmount, decimal, currency, "AllowanceCore");

            const contract = usdtContract(contractAddress, web3);

            let amount = decimal === 18
                ? web3.utils.toWei(rewardAmount.toString(), 'ether')
                : (rewardAmount * Math.pow(10, decimal)).toString();

            amount = parseFloat(amount)?.toFixed();
            amount = amount?.toString();

            var gasFunPrice;

            try {
                const currentAllowance = await contract.methods.allowance(account, allowanceAddresss).call();
                console.log(currentAllowance, "AllowanceCore 2");
                if (parseFloat(currentAllowance) >= parseFloat(amount)) {
                    console.log(currentAllowance, "AllowanceCore 3");
                    return currentAllowance;
                }

                if (currency === 'USDT' && parseFloat(currentAllowance) < parseFloat(amount) && parseFloat(currentAllowance) !== 0) {
                    const gasZero = await contract.methods.approve(allowanceAddresss, "0").estimateGas({
                        from: account,
                    });
                    web3.eth.getGasPrice().then((result) => {
                        var result2 = parseInt(result);
                        gasFunPrice = result2.toString();
                    });
                    await contract.methods.approve(allowanceAddresss, "0").send({
                        from: account,
                        gas: gasZero,
                        gasPrice: gasFunPrice,
                    });
                    console.log('currentAllowance', "AllowanceCore 4");
                }

                web3.eth.getGasPrice().then((result) => {
                    var result2 = parseInt(result);
                    gasFunPrice = result2.toString();
                });
                await contract.methods.approve(allowanceAddresss, amount).send({
                    from: account,
                    gasPrice: gasFunPrice,
                });

                const newAllowance = await contract.methods.allowance(account, allowanceAddresss).call();
                console.log(newAllowance, "AllowanceCore 3");
                if (parseFloat(newAllowance) < parseFloat(amount)) {
                    throw new Error("Allowance is still less than the required amount after approval.");
                }

                return newAllowance;
            } catch (error) {
                console.error('Error during allowance check/approval:', error);
                throw new Error("Error occurred while checking or approving allowance.");
            }
        },
        [web3, account]
    );

    return { AllowanceCore, checkAllowanceOnly };
};

export default Allowance;